import { hygraphClient } from '@/lib/graphql-clients';
import { getSdk, Region } from '@/lib/types';

const getAll = async (): Promise<Region[]> => {
  const sdk = getSdk(hygraphClient(false));
  const regions = (await sdk.Regions()).regions;

  return regions as unknown as Region[];
};

const JobCategoryPageRegionsService = {
  getAll,
};

export default JobCategoryPageRegionsService;
